import { Box } from "@mui/material";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./footer";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { SidebarProvider } from "./sidebarcontext";

import { useEffect } from "react";

interface LayoutProps {
  children: React.ReactNode;
  title?: string;
}

export default function Layout({ children, title }: LayoutProps) {
  useEffect(() => {
    if (title) {
      document.title = `${title} | United Grooves Admin Panel`;
    } else {
      document.title = "United Grooves Admin Panel";
    }
  }, [title]);

   const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const sidebarWidth = isTablet ? "200px" : "240px";

  return (
    <SidebarProvider>
      <Box display="flex">
        <Sidebar />
        <Box 
          flex={1} 
          display="flex" 
          flexDirection="column"
          sx={{
            marginLeft: isMobile ? 0 : sidebarWidth,
            minWidth: 0,
            height: "100vh", 
            overflow: "hidden", 
            transition: "margin-left 0.2s ease",
          }}
        >
          <Header /> 
          <Box
            component="main"
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              bgcolor: "#F7FAF3",
              overflowY: "auto", 
              overflowX: "hidden",
              paddingTop: "56px", 
              paddingBottom: "20px", 
            }}
          >
            <Box
              width="100%"
              maxWidth="1200px"
              minWidth={0}
              p={{ xs: 2.5, md: 3 }}
            >
              {children}
            </Box>
          </Box>
          
          {!isMobile && <Footer style={{ position: "relative", zIndex: 10 }} />}
        </Box>
      </Box>
    </SidebarProvider>
  );
}
